import { ButtonPrimary, ButtonSecondary, DialogActions, styled, Typography, uiTokens } from '@msdk/ui'

interface FooterButtonProps {
  label: string
  onClick: () => void
  disabled?: boolean
}

interface FooterPopupProps {
  primary?: FooterButtonProps
  secondary?: FooterButtonProps
  noBorderSecondary?: FooterButtonProps
}

export const StyledDialogActions = styled(DialogActions)`
  gap: ${uiTokens.spacing.gap.small}px;
  justify-content: flex-end;
  padding: ${uiTokens.spacing.padding.medium}px;
`

const StyledButtonSecondary = styled(ButtonSecondary)`
  &.MuiButtonBase-root {
    pointer-events: auto;
    background-color: transparent;
    box-shadow: none;
  }
`

export function FooterPopup({ primary, secondary, noBorderSecondary }: FooterPopupProps) {
  return (
    <StyledDialogActions>
      {secondary && (
        <ButtonSecondary onClick={secondary.onClick}>
          <Typography variant="button">{secondary.label}</Typography>
        </ButtonSecondary>
      )}
      {noBorderSecondary && (
        <StyledButtonSecondary onClick={noBorderSecondary.onClick}>
          <Typography variant="button">{noBorderSecondary.label}</Typography>
        </StyledButtonSecondary>
      )}
      {primary && (
        <ButtonPrimary onClick={primary.onClick} disabled={primary.disabled}>
          <Typography variant="button">{primary.label}</Typography>
        </ButtonPrimary>
      )}
    </StyledDialogActions>
  )
}
